<app-week-calendar
  [loading]="loading"
  [events]="events"
  (dateUpdate)="focusDate = $event"
  (openHelpModal)="openHelpModal.emit()"
></app-week-calendar>
